import { httpwmsapi } from 'src/services';
import queryString from 'query-string';

// Action Types
export const Types = {
  RECEIVING_LOADING: 'receiving/loading',

  RECEIVING_SET_DATA: 'receiving/set/data',
  RECEIVINGS_SET_DATA: 'receivings/set/data',
  RECEIVINGS_SET_PAGING: 'receivings/set/paging',
  RECEIVINGS_SET_FILTER: 'receivings/set/filter',

  RECEIVING_INVOICE_SET_DATA: 'receiving_invoice/set/data',
  RECEIVING_INVOICES_SET_DATA: 'receiving_invoices/set/data',
  RECEIVING_INVOICES_SET_PAGING: 'receiving_invoices/set/paging',
  RECEIVING_INVOICES_SET_FILTER: 'receiving_invoices/set/filter',

  RECEIVING_INVOICE_PRODUCT_SET_DATA: 'receiving_invoice_prod/set/products/data',
  RECEIVING_INVOICE_PRODUCTS_SET_DATA: 'receiving_invoice_prods/set/products/data',
  RECEIVING_INVOICE_PRODUCTS_SET_PAGING: 'receiving_invoice_prods/set/products/paging',
  RECEIVING_INVOICE_PRODUCTS_SET_FILTER: 'receiving_invoice_prods/set/products/filter',
  RECEIVING_DASHBOARD_SET_DATA: 'receiving_dashboard/set/data',
  RECEIVING_DASHBOARD_NEXT_RECEIVES_SET_DATA: 'receiving_dashboard_next_receives/set/data',
};

// Reducer
const initialState = {
  loading: false,

  receiving: {},
  receivings: [],
  receivings_paging: { limit: 25, offset: 0, total: 0, page: 0 },
  receivings_filters: [],

  receiving_invoice: {},
  receiving_invoices: [],
  receiving_invoices_paging: { limit: 25, offset: 0, total: 0, page: 0 },
  receiving_invoices_filters: [],

  receiving_invoice_product: {},
  receiving_invoice_products: [],
  receiving_invoice_products_paging: {
    limit: 25,
    offset: 0,
    total: 0,
    page: 0,
  },
  receiving_invoice_products_filters: [],

  receiving_dashboard: [],
  receiving_dashboard_next_receives: [],
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.RECEIVING_LOADING:
      return { ...state, loading: action.payload };

    case Types.RECEIVING_SET_DATA:
      return { ...state, receiving: action.payload };
    case Types.RECEIVINGS_SET_DATA:
      return { ...state, receivings: action.payload };
    case Types.RECEIVINGS_SET_PAGING:
      return { ...state, receivings_paging: action.payload };
    case Types.RECEIVINGS_SET_FILTER:
      return { ...state, receivings_filters: action.payload };

    case Types.RECEIVING_INVOICE_SET_DATA:
      return { ...state, receiving_invoice: action.payload };
    case Types.RECEIVING_INVOICES_SET_DATA:
      return { ...state, receiving_invoices: action.payload };
    case Types.RECEIVING_INVOICES_SET_PAGING:
      return { ...state, receiving_invoices_paging: action.payload };
    case Types.RECEIVING_INVOICES_SET_FILTER:
      return { ...state, receiving_invoices_filters: action.payload };

    case Types.RECEIVING_INVOICE_PRODUCT_SET_DATA:
      return { ...state, receiving_invoice_product: action.payload };
    case Types.RECEIVING_INVOICE_PRODUCTS_SET_DATA:
      return { ...state, receiving_invoice_products: action.payload };
    case Types.RECEIVING_INVOICE_PRODUCTS_SET_PAGING:
      return { ...state, receiving_invoice_products_paging: action.payload };
    case Types.RECEIVING_INVOICE_PRODUCTS_SET_FILTER:
      return { ...state, receiving_invoice_products_filters: action.payload };

    case Types.RECEIVING_DASHBOARD_SET_DATA:
      return { ...state, receiving_dashboard: action.payload };
    case Types.RECEIVING_DASHBOARD_NEXT_RECEIVES_SET_DATA:
      return { ...state, receiving_dashboard_next_receives: action.payload };

    default:
      return state;
  }
}

export const Creators = {
  receivingLoading: (value) => ({
    type: Types.RECEIVING_LOADING,
    payload: value,
  }),

  receivingSetData: (receiving) => ({
    type: Types.RECEIVING_SET_DATA,
    payload: receiving,
  }),
  receivingsSetData: (receivings) => ({
    type: Types.RECEIVINGS_SET_DATA,
    payload: receivings,
  }),
  receivingsSetPaging: (receivings_paging) => ({
    type: Types.RECEIVINGS_SET_PAGING,
    payload: receivings_paging,
  }),
  receivingsSetFilters: (receivings_filters) => ({
    type: Types.RECEIVINGS_SET_FILTER,
    payload: receivings_filters,
  }),

  receivingInvoiceSetData: (receivingInvoice) => ({
    type: Types.RECEIVING_INVOICE_SET_DATA,
    payload: receivingInvoice,
  }),
  receivingInvoicesSetData: (receivingInvoices) => ({
    type: Types.RECEIVING_INVOICES_SET_DATA,
    payload: receivingInvoices,
  }),
  receivingInvoicesSetPaging: (receivingInvoices_paging) => ({
    type: Types.RECEIVING_INVOICES_SET_PAGING,
    payload: receivingInvoices_paging,
  }),
  receivingInvoicesSetFilters: (receivingInvoices_filters) => ({
    type: Types.RECEIVING_INVOICES_SET_FILTER,
    payload: receivingInvoices_filters,
  }),

  receivingInvoiceProductSetData: (receivingInvoicesProduct) => ({
    type: Types.RECEIVING_INVOICE_PRODUCT_SET_DATA,
    payload: receivingInvoicesProduct,
  }),
  receivingInvoiceProductsSetData: (receivingInvoicesProducts) => ({
    type: Types.RECEIVING_INVOICE_PRODUCTS_SET_DATA,
    payload: receivingInvoicesProducts,
  }),
  receivingInvoiceProductsSetPaging: (receivingInvoicesProducts_paging) => ({
    type: Types.RECEIVING_INVOICE_PRODUCTS_SET_PAGING,
    payload: receivingInvoicesProducts_paging,
  }),
  receivingInvoiceProductsSetFilters: (receivingInvoicesProducts_filters) => ({
    type: Types.RECEIVING_INVOICE_PRODUCTS_SET_FILTER,
    payload: receivingInvoicesProducts_filters,
  }),

  receivingDashboardSetData: (receivingDashboard) => ({
    type: Types.RECEIVING_DASHBOARD_SET_DATA,
    payload: receivingDashboard,
  }),
  receivingDashboardNextReceivesSetData: (receivingDashboardNextReceives) => ({
    type: Types.RECEIVING_DASHBOARD_NEXT_RECEIVES_SET_DATA,
    payload: receivingDashboardNextReceives,
  }),

  getReceivings: (filters = {}) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' }).replaceAll('%5B', '[').replaceAll('%5D', ']');
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/recebimento/?${qry}`, { timeout: 1000 * 50 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  getReceivingInvoices: (filters = {}) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' }).replaceAll('%5B', '[').replaceAll('%5D', ']');
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/recebimento-nota/?${qry}`, { timeout: 1000 * 50 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  getReceiving: (filters = {}) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' }).replaceAll('%5B', '[').replaceAll('%5D', ']');
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/recebimento-nota/receiving?${qry}`, { timeout: 1000 * 50 })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => reject(error));
    });
  },

  getReceivingInvoiceProducts: (filters = {}) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' }).replaceAll('%5B', '[').replaceAll('%5D', ']');
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/recebimento-nota-prod/?${qry}`, { timeout: 1000 * 50 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  putReceiving: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .put(`/v1/recebimento/`, body, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  setReceiving: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/recebimento/`, body, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  setReceivingInvoiceProduct: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/recebimento-nota-prod/`, body, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  deleteReceivingInvoiceProduct: (receiving_code, gtin_product, created_by) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .delete(`/v1/recebimento-nota-prod/${receiving_code}/${gtin_product}/${created_by}`, {
          timeout: 1000 * 15,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  cancelReceiving: (codigo, reason = '') => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .patch(`/v1/recebimento/${codigo}/cancelar`, { reason }, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  finishReceiving: (codigo, reason = '') => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .patch(`/v1/recebimento/${codigo}/finalizar`, { reason }, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  finishReceivingInvoice: (codigo, body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .patch(`/v1/recebimento-nota/${codigo}`, body, {
          timeout: 1000 * 15,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  updateReceivingInvoiceVolumes: (receiving_invoice_code, volumes) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .patch(`/v1/recebimento-nota/${receiving_invoice_code}/${volumes}`, {
          timeout: 1000 * 15,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  getDashboardData: () => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/recebimento/dashboard`, { timeout: 1000 * 50 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  getProximosRecebimentos: () => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/recebimento/dashboard/proximos-recebimentos`, {
          timeout: 1000 * 50,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
};
